// extracted by mini-css-extract-plugin
export default {"circular_loader":"loader_circular_loader__wt+Da","rotate":"loader_rotate__Ry1fF","loader_path":"loader_loader_path__OZdN+","dash":"loader_dash__15NAZ","color":"loader_color__9sbG8"};